import React from "react";
import "./errorPage.css";

const ErrorPage = () => {
  return (
    <div className="errorPage">
      <span className="text404">404</span>
    </div>
  );
};

export default ErrorPage;
